import api from './api';

export interface Ubicacion {
    nroUbicacion: number;
    nombreUbicacion: string;
    nroSuc: number;
    credito?: number;
    nroCentroCosto?: number;
    enConsignacion?: number;
    fechaVencim?: Date;
    tipoUbicacion?: string;
    direccion?: string;
    sincronizar?: number;
    telefono?: string;
    responsable?: string;
}

export interface UbicacionSearchParams {
    searchTerm?: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface UbicacionPagedResult {
    items: Ubicacion[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
}

const ubicacionService = {
    getUbicaciones: async (params?: UbicacionSearchParams): Promise<Ubicacion[]> => {
        const response = await api.get('/api/Ubicaciones', params ? { params } : {});
        const data = response.data;
        if (Array.isArray(data)) return data;
        if (data && typeof data === 'object' && 'items' in data) {
            return data.items as Ubicacion[];
        }
        return [];
    },

    getUbicacionesPaged: async (params: UbicacionSearchParams): Promise<UbicacionPagedResult> => {
        const response = await api.get('/api/Ubicaciones', { params });
        const data = response.data;
        const pageNumber = params.pageNumber || 1;
        const pageSize = params.pageSize || 10;
        
        if (Array.isArray(data)) {
            return {
                items: data,
                totalCount: data.length,
                pageNumber: pageNumber,
                pageSize: pageSize,
                totalPages: Math.ceil(data.length / pageSize)
            };
        }
        
        if (data && typeof data === 'object' && 'items' in data) {
            return data as UbicacionPagedResult;
        }
        
        return {
            items: [],
            totalCount: 0,
            pageNumber: pageNumber,
            pageSize: pageSize,
            totalPages: 0
        };
    },

    getUbicacion: async (nroUbicacion: number): Promise<Ubicacion> => {
        const response = await api.get(`/api/Ubicaciones/${nroUbicacion}`);
        return response.data;
    },

    createUbicacion: async (ubicacion: Ubicacion): Promise<Ubicacion> => {
        const response = await api.post<Ubicacion>('/api/Ubicaciones', ubicacion);
        return response.data;
    },

    updateUbicacion: async (nroUbicacion: number, ubicacion: Ubicacion): Promise<void> => {
        await api.put(`/api/Ubicaciones/${nroUbicacion}`, ubicacion);
    },

    deleteUbicacion: async (nroUbicacion: number): Promise<void> => {
        await api.delete(`/api/Ubicaciones/${nroUbicacion}`);
    }
};

export default ubicacionService; 